/**
 * The only configuration this app reads. Vite inlines `VITE_*` at build time,
 * so anything added here ships to the browser in clear text — an origin is the
 * limit of what may live in that file (CLAUDE.md §4.5).
 */

/**
 * Empty string means "same origin", which is the deployed shape: Caddy serves
 * the SPA and proxies `/api` to the API from one hostname, so the admin build
 * needs no origin at all. A separate origin is a local-development and
 * preview-environment concern, and that is what the variable is for.
 */
export const API_BASE_URL: string = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '');

export const API_PREFIX = '/api/v1';

export function apiUrl(path: string): string {
  return `${API_BASE_URL}${API_PREFIX}${path}`;
}
